require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-bic-welcomes-new-world-bank-president-ajay-banga.json") })
        }
      }, "path---en-us-update-bic-welcomes-new-world-bank-president-ajay-banga");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-bic-welcomes-new-world-bank-president-ajay-banga!./.cache/json/en-us-update-bic-welcomes-new-world-bank-president-ajay-banga.json
// module id = 630
// module chunks = 231608221292675